module.exports = __webpack_public_path__ + "static/media/Direct Message White.7203d4b5.svg";